export const FI: Record<string, string> = {
  "Recommended for you": "Suositellut sinulle",
  "Resource added to favorite": "Resurssi lisätty suosikkeihin",
  "Failed to add resource to favorite": "Resurssin lisääminen suosikkeihin epäonnistui",
  "Resource removed from favorite": "Resurssi poistettu suosikeista",
  "Failed to remove resource from favorite": "Resurssin poistaminen suosikeista epäonnistui",
  "Calendar": "Kalenteri",
  "View Detail": "Näytä yksityiskohdat",
  "Add to favorites": "Lisää suosikkeihin",
  "Remove from favorites": "Poista suosikeista",
  "Description: VIP meeting room with a great view and comfortable chairs.": "Kuvaus: VIP-kokoushuone, jossa on upea näkymä ja mukavat tuolit.",
  
  // NoResultFound
  // case default resource type
  "There are no available resources at the chosen time at your location or in your favorites.": "Valittuna aikana ei ole saatavilla resursseja sijainnissasi tai suosikeissasi.",
  "You have these options:": "Sinulla on nämä vaihtoehdot:",
  "Change the meeting time.": "Vaihda kokouksen aika.",
  "Use the <1>Find Available Time</1> button to choose a new time.": "Käytä <1>Etsi vapaa aika</1> -painiketta valitaksesi uuden ajan.",
  "Open the search to find other resources.": "Avaa haku löytääksesi muita resursseja.",
  // case not default resource type
  "The resource type <1>'{{resourceType}}'</1> does not exist on your default location": "Resurssityyppi <1>'{{resourceType}}'</1> ei ole saatavilla oletussijainnissasi",
  "The resource type <1>'{{resourceType}}'</1> can be found on a different location.": "Resurssityyppi <1>'{{resourceType}}'</1> voi löytyä toisesta sijainnista.",
  "<1>Click here</1> to add the resource type to your default location settings.": "<1>Napsauta tästä</1> lisätäksesi resurssityypin oletussijaintiasetuksiin.",
  
  // ResourceCard
  "New Order": "Uusi tilaus",
  "When booking a Pooled Resource, only this resource type and only one can be booked.": "Varataessa Pooled Resourceia voidaan varata vain tämä resurssityyppi ja vain yksi resurssi.",
  "You cannot select both a child resource and its virtual resource at the same time.": "Et voi valita sekä lapsiresurssia että sen virtuaaliresurssia samalla kertaa.",
  // Settings
  "Note:": "Huomautus:",
  "An Assistant Organizer can receive the same emails from Resource Central as the organizer and can handle orders on behalf of the organizer.": "Järjestäjän avustaja voi vastaanottaa samat sähköpostit Resource Centralista kuin järjestäjä ja käsitellä tilauksia järjestäjän puolesta.",
  "Setting updated successfully": "Asetus päivitetty onnistuneesti",
  "Setting updated failed": "Asetuksen päivitys epäonnistui",
  "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)": "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)",
  
  // ModalResourceDetail
  "1 space": "1 paikka",
  "Opening hours:": "Aukioloajat:",
  "Buffer time {{minutes}} mins between reservations": "Puskuriaika {{minutes}} min varausten välillä",
  "Initial payment {{value}} pr.minute": "Alkumaksu {{value}} minuutilta",
  
  // FindAvailableTime
  "Total {{total}} Attendees": "Yhteensä {{total}} osallistujaa",
  "{{internal}} of {{total}} internal can attend.": "{{internal}}/{{total}} sisäistä voi osallistua.",
  "{{external}} external is unknown.": "{{external}} ulkoista on tuntematon.",
  "Find available time": "Etsi vapaa aika",
  "Attendees": "Osallistujat",
  
  // HelpSetting
  "Click on Further information to visit our support site": "Napsauta Lisätietoja vieraillaksesi tukisivustollamme",
  "Further information": "Lisätietoja",
  
  // LocationSetting
  "Location changed": "Sijainti vaihdettu",
  "Location change failed": "Sijainnin vaihto epäonnistui",
  "Please select at least one location": "Valitse vähintään yksi sijainti",
  "Resource types": "Resurssityypit",
  "Location": "Sijainti",
  "Where": "Missä",
  
  // ModalShowAttendees
  "Total": "Yhteensä",
  "Available": "Saatavilla",
  "Busy": "Varattu",
  "External": "Ulkoinen",
  "Internal": "Sisäinen",
  
  // ResourceSearch
  "Search by resource name": "Hae resurssin nimellä",
  "Category": "Kategoria",
  "Filter by Location": "Suodata sijainnin mukaan",
  "Filter by Category": "Suodata kategorian mukaan",
  "Capacity": "Kapasiteetti",
  "Filter by Capacity": "Suodata kapasiteetin mukaan",
  "All": "Kaikki",
  "Filter by availability": "Suodata saatavuuden mukaan",
  "Sort By": "Lajittele",
  "Loading...": "Ladataan...",
  
  // SelectedResources
  "Meeting Type": "Kokouksen tyyppi",
  "Meeting Label": "Kokouksen merkintä",
  
  // Alert (accessibility text)
  "Check icon": "Valintamerkki-kuvake",
  "Close": "Sulje",
  
  // AppConstants - searchTab
  "Resource": "Resurssi",
  "Person": "Henkilö",
  
  // AppConstants - listQuestionsStart
  "Where do your meetings usually take place?": "Missä kokouksesi yleensä pidetään?",
  "To improve our recommendations for you we would like you to enter your normal location": "Suositusten parantamiseksi haluaisimme, että annat tavallisen sijaintisi",
  "What do you use most?": "Mitä käytät eniten?",
  "To enable quicker and better search please chose you prefered resource type": "Nopeamman ja paremman haun mahdollistamiseksi valitse haluamasi resurssilaji",
  
  // AppConstants - titlePages
  "Click on resource to pick": "Valitse resurssi napsauttamalla",
  "Selected Resources": "Valitut resurssit",
  "Setting": "Asetus",
  "Search": "Haku",
  "Find Colleague": "Etsi kollega",
  "Quick button setting": "Pikanäppäimen asetus",
  "Favorite": "Suosikki",
  "Most Used": "Eniten käytetty",
  "Colleagues": "Kollegat",
  "Resources": "Resurssit",
  
  // AppConstants - tooltipText
  "Back": "Takaisin",
  "Floor Plan": "Pohjapiirros",
  "Expand": "Laajenna",
  "Selected resources": "Valitut resurssit",
  "View details": "Näytä yksityiskohdat",
  "Remove from My Favorites": "Poista suosikeista",
  "Add to My Favorites": "Lisää suosikkeihin",
  "Remove": "Poista",
  "Favorite - Most Used": "Suosikki - Eniten käytetty",
  "Conflict": "Ristiriita",
  "Approved": "Hyväksytty",
  "Recommendeded for you": "Suositeltu sinulle",
  
  // AppConstants - mailFlowOptions
  "Only primary organizer": "Vain ensisijainen järjestäjä",
  "Only assistant organizer": "Vain järjestäjän avustaja",
  "Primary AND assistant organizer": "Ensisijainen JA järjestäjän avustaja",
  
  // FindColleague
  "Enter colleague name": "Anna kollegan nimi",
  "Recent work items": "Viimeaikaiset työkohteet",
  "No data available": "Ei tietoja saatavilla",
  "Floorplan": "Pohjapiirros",
  "List nearby resources": "Luettelo läheisistä resursseista",
  "Find resource nearby": "Etsi lähellä oleva resurssi",
  "No Resources available": "Ei resurssia saatavilla",
  
  // Start page
  "Next": "Seuraava",
  "Failed to update default locations": "Oletussijaintien päivitys epäonnistui",
  "Resource Type": "Resurssilaji",
  
  // QuickSetting
  "Quick buttons updated successfully": "Pikanäppäimet päivitetty onnistuneesti",
  "Quick buttons updated failed": "Pikanäppäinten päivitys epäonnistui",
  "Add more": "Lisää enemmän",
  "Apply": "Käytä",
  "Delete": "Poista",
  "Name": "Nimi",
  "Enter name": "Anna nimi",
  "Tooltip": "Työkaluvihje",
  "Enter tooltip": "Anna työkaluvihje",
  "Type": "Tyyppi",
  "Select type": "Valitse tyyppi",
  "Locations": "Sijainnit",
  "Select colleagues": "Valitse kollegat",
  "Select resources": "Valitse resurssit",
  
  // DefaultResourceSetting
  "Resource type changed": "Resurssilaji vaihdettu",
  "Resource type change failed": "Resurssilajin vaihto epäonnistui",
  "Default Resource Type": "Oletusresurssilaji",
  
  // AssistantOrganizerSetting
  "Apply Successfully": "Käytetty onnistuneesti",
  "Apply Failed": "Käyttö epäonnistui",
  "Assistant Organizer": "Järjestäjän avustaja",
  "Enter a part of the name to search for": "Anna osa nimestä hakeaksesi",
  "Mail Flow": "Sähköpostivirta",
  "Select Mail Flow": "Valitse sähköpostivirta",
  
  // TileConfigurationSetting
  "Update settings successfully": "Asetukset päivitetty onnistuneesti",
  "Update settings failed": "Asetusten päivitys epäonnistui",
  "Timeline": "Aikajana",
  
  // SelectCategoryForm
  "And": "Ja",
  "Or": "Tai",
  
  // Other
  "Resource Calendar": "Resurssi kalenteri",
  
  // SettingLabels
  "Default Location": "Oletussijainti",
  "Quick button": "Pikanäppäin",
  "Category icons": "Kategoria-ikonit",
  "Recommendation screen": "Suositusnäyttö",
  "Capacity filter": "Kapasiteettisuodatin",
  "AI Assistant": "AI-avustaja",
  "Tile configuration": "Ruudukon asetukset",
  "Help": "Ohje",
  "Default Categories": "Oletusluokat",
  
  // MeetingType
  "Your must select a Meeting label": "Sinun on valittava kokousmerkki",
  
  // AlternativeResource
  "Selected Resource: 'AOD_Copanhagen' Conflicting Occurrences": "Valittu resurssi: 'AOD_Copanhagen' Ristiriitaiset esiintymät",
  "Alternative Resource": "Vaihtoehtoinen resurssi",
  "OK": "OK",
  "Cancel": "Peruuta",
  
  // RemovedResource
  "Your selected resources 'AOD_Copenhagen' was removed": "Valitsemasi resurssi 'AOD_Copenhagen' poistettiin",
  "You can't book this resource as your request exceeds the available capacity.": "Et voi varata tätä resurssia, koska pyyntösi ylittää saatavilla olevan kapasiteetin.",
  
  // ChangeTime
  "Time changed successfully": "Aika vaihdettu onnistuneesti",
  "Current Time": "Nykyinen aika",
  "Suggested Times": "Ehdotetut ajat",
  "Change Time": "Vaihda aika",
  "people are free": "henkilöä on vapaana",
};

